import {
  Clock,
  AlertTriangle,
  TrendingDown,
  Users,
  AlertCircle,
} from 'lucide-react'
import { Card, CardContent } from '@/components/ui/card'
import { useIntersectionObserver } from '@/hooks/use-intersection-observer'
import { cn } from '@/lib/utils'

export function Reality() {
  const { elementRef, isVisible } = useIntersectionObserver()

  const painPoints = [
    {
      icon: Users,
      title: 'Aulas ficam descobertas',
      desc: 'Alunos sem professor geram reclamações imediatas dos pais.',
    },
    {
      icon: Clock,
      title: 'Coordenação perde horas',
      desc: 'Tempo precioso gasto triando currículos desqualificados.',
    },
    {
      icon: AlertTriangle,
      title: 'Contratações no desespero',
      desc: "Fechar a vaga com quem 'apareceu' e não com quem é bom.",
    },
    {
      icon: TrendingDown,
      title: 'Instabilidade percebida',
      desc: 'A rotatividade constante prejudica a imagem pedagógica.',
    },
  ]

  return (
    <section ref={elementRef} className="py-20 bg-slate-900 text-white">
      <div className="container mx-auto px-4">
        <div
          className={cn(
            'text-center mb-16 space-y-4',
            isVisible ? 'animate-fade-in-up' : 'opacity-0',
          )}
        >
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-orange-500/20 text-orange-400 text-sm font-bold uppercase tracking-wider">
            <AlertCircle className="w-4 h-4" />A Realidade das Escolas
          </div>
          <h2 className="text-3xl md:text-4xl font-bold">
            Vaga aberta não é apenas um detalhe.
          </h2>
          <p className="text-xl text-slate-400 max-w-2xl mx-auto">
            É um problema que cresce silenciosamente e afeta toda a estrutura
            escolar.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {painPoints.map((point, index) => (
            <Card
              key={index}
              className={cn(
                'bg-slate-800 border-slate-700 text-slate-100 hover:bg-slate-750 transition-all duration-300 hover:-translate-y-1',
                isVisible ? `animate-fade-in-up` : 'opacity-0',
              )}
              style={{ animationDelay: `${index * 150}ms` }}
            >
              <CardContent className="p-6 flex flex-col items-center text-center h-full">
                <div className="w-14 h-14 rounded-full bg-slate-900/50 border border-slate-700 flex items-center justify-center mb-4 text-brand-orange">
                  <point.icon className="w-7 h-7" />
                </div>
                <h3 className="text-lg font-bold mb-2 text-white">
                  {point.title}
                </h3>
                <p className="text-sm text-slate-400 leading-relaxed">
                  {point.desc}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>

        <div
          className={cn(
            'mt-16 text-center',
            isVisible ? 'animate-fade-in' : 'opacity-0',
          )}
        >
          <p className="text-2xl md:text-3xl font-bold text-brand-orange">
            Isso custa tempo, dinheiro e reputação.
          </p>
        </div>
      </div>
    </section>
  )
}
